export interface StapRijgedragState {
  kmPerDag: number;
  kmPiekDag: number;
  dagenPerWeek: number;
  langeRitten: boolean;
  aantalEvs: 1 | 2 | 3;
}

interface Props {
  state: StapRijgedragState;
  onChange: (next: StapRijgedragState) => void;
  onNext: () => void;
  onBack: () => void;
  heeftEV: boolean | null;
}

const AANTAL_EVS_OPTIES: { value: 1 | 2 | 3; label: string }[] = [
  { value: 1, label: '1 auto' },
  { value: 2, label: "2 auto's" },
  { value: 3, label: '3 of meer' },
];

export default function StapRijgedrag({ state, onChange, onNext, onBack, heeftEV }: Props) {
  void heeftEV;
  return (
    <div className="lc-stap lc-stap--rijgedrag">
      <h2 className="lc-stap__titel">Stap 2 — Jouw rijgedrag</h2>

      {/* km per day slider */}
      <div className="lc-veld">
        <label className="lc-label" htmlFor="lc-km-per-dag">
          Hoeveel km verwacht je dagelijks te rijden?
          <span className="lc-slider__waarde"> {state.kmPerDag} km</span>
        </label>
        <input
          id="lc-km-per-dag"
          type="range"
          className="lc-slider"
          min={10}
          max={200}
          step={5}
          value={state.kmPerDag}
          onChange={(e) => {
            const kmPerDag = Number(e.target.value);
            const kmPiekDag = Math.max(state.kmPiekDag, Math.round(kmPerDag * 1.5));
            onChange({ ...state, kmPerDag, kmPiekDag });
          }}
        />
        <div className="lc-slider__labels">
          <span>10 km</span>
          <span>200 km</span>
        </div>
      </div>

      {/* peak day km slider */}
      <div className="lc-veld">
        <label className="lc-label" htmlFor="lc-km-piek-dag">
          Hoeveel km verwacht je op je drukste dag te rijden?
          <span className="lc-slider__waarde"> {state.kmPiekDag} km</span>
        </label>
        <p className="lc-info-tekst">Op een drukke dag kun je bijna leeg thuiskomen. Daar houden we rekening mee in het advies.</p>
        <input
          id="lc-km-piek-dag"
          type="range"
          className="lc-slider"
          min={10}
          max={500}
          step={5}
          value={state.kmPiekDag}
          onChange={(e) => onChange({ ...state, kmPiekDag: Number(e.target.value) })}
        />
        <div className="lc-slider__labels">
          <span>10 km</span>
          <span>500 km</span>
        </div>
      </div>

      {/* days per week slider */}
      <div className="lc-veld">
        <label className="lc-label" htmlFor="lc-dagen-per-week">
          Hoe vaak per week verwacht je te rijden?
          <span className="lc-slider__waarde"> {state.dagenPerWeek} dag{state.dagenPerWeek !== 1 ? 'en' : ''}</span>
        </label>
        <input
          id="lc-dagen-per-week"
          type="range"
          className="lc-slider"
          min={1}
          max={7}
          step={1}
          value={state.dagenPerWeek}
          onChange={(e) => onChange({ ...state, dagenPerWeek: Number(e.target.value) })}
        />
        <div className="lc-slider__labels">
          <span>1 dag</span>
          <span>7 dagen</span>
        </div>
      </div>

      {/* number of EVs */}
      <fieldset className="lc-fieldset">
        <legend className="lc-label">Hoeveel auto's verwacht je thuis op te laden?</legend>
        <div className="lc-toggle-groep">
          {AANTAL_EVS_OPTIES.map(({ value, label }) => (
            <button
              key={value}
              type="button"
              className={`lc-toggle${state.aantalEvs === value ? ' lc-toggle--actief' : ''}`}
              onClick={() => onChange({ ...state, aantalEvs: value })}
            >
              {label}
            </button>
          ))}
        </div>
      </fieldset>

      {/* long trips toggle */}
      <fieldset className="lc-fieldset">
        <legend className="lc-label">Verwacht je regelmatig lange ritten te maken (meer dan 200 km)?</legend>
        <p className="lc-info-tekst">Als je verwacht regelmatig lange ritten te maken van meer dan 200 km, kun je soms bijna leeg thuiskomen. Dan heb je een snellere laadpaal nodig om de auto 's nachts weer vol te krijgen.</p>
        <div className="lc-toggle-groep">
          <button
            type="button"
            className={`lc-toggle${state.langeRitten ? ' lc-toggle--actief' : ''}`}
            onClick={() => onChange({ ...state, langeRitten: true })}
          >
            Ja
          </button>
          <button
            type="button"
            className={`lc-toggle${!state.langeRitten ? ' lc-toggle--actief' : ''}`}
            onClick={() => onChange({ ...state, langeRitten: false })}
          >
            Nee
          </button>
        </div>
      </fieldset>

      {/* Navigation */}
      <div className="lc-navigatie">
        <button type="button" className="lc-btn lc-btn--secundair" onClick={onBack}>
          ← Terug
        </button>
        <button type="button" className="lc-btn lc-btn--primair" onClick={onNext}>
          Volgende stap →
        </button>
      </div>
    </div>
  );
}
